import { Component, HostListener, Input, OnInit, ViewEncapsulation } from "@angular/core";
import { PaymentMethodType, PaymentService } from "@aparraga/ahoracrypto-client-common/src/app/common/payment/payment.service";

@Component({
    templateUrl: './paymentchooser.component.html',
    styleUrls: ['./paymentchooser.component.scss'],
    selector: 'paymentchooser',
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class PaymentChooserComponent implements OnInit {

  @Input() showAsPopup: boolean = true; // Default to popup display
  

  public visiblePaymentMethods: any[] = [];
  public showPayOptions: boolean = false;
  private animationDuration: number = 300; // Animation duration in ms
  public activePaymentMethod: any;

  constructor(
    public paymentService: PaymentService,
  ) {}

  ngOnInit() {

    this.paymentService.paymentMethods$.subscribe(paymentMethods => {
      this.updateVisiblePaymentMethods();
    });

  }

  // Update visible payment methods based on the filtering rules
  private updateVisiblePaymentMethods() {
    if (!this.paymentService.getPaymentMethods() || this.paymentService.getPaymentMethods().length === 0) {
      this.visiblePaymentMethods = [];
      return;
    }

    const visibleMethods: any[] = [];

    // For types 1 and 2, only add the highest priority method
    [PaymentMethodType.CREDIT_CARD, PaymentMethodType.BANK_TRANSFER].forEach(type => {
      const highestPriorityMethod = this.paymentService.getHighestPriorityMethodByType(type);
      if (highestPriorityMethod) {
        visibleMethods.push(highestPriorityMethod);
      }
    });

    // For type 3, add all methods
    const type3Methods = this.paymentService.getPaymentMethods().filter(method => method.type >= 3);
    this.visiblePaymentMethods = [...visibleMethods, ...type3Methods];
  }

  // Handle escape key press
  @HostListener('document:keydown.escape')
  handleEscapeKey() {
    if (this.showPayOptions) {
      this.togglePayOptions();
    }
  }

  // Select payment method
  public selectPaymentMethod(paymentMethod) {
    this.paymentService.setActivePaymentMethod(paymentMethod);
    this.togglePayOptions(); // Close the options after selection
  }

  // Toggle payment options modal with animation
  public togglePayOptions() {
    this.showPayOptions = !this.showPayOptions;
  }

}
